const messages = {
  en: {
    title: 'Professional Support',
    subtitle: 'We have answers to your questions',
    searchplaceholder: 'Search to get started',
    or: '..or choose an option below',
    producttrigger: 'Browse Products',
    faqtrigger: 'View popular FAQs'
  },
  'es-ud': {
    title: 'Soporte Profesional',
    subtitle: 'Tenemos respuestas para tus preguntas',
    searchplaceholder: 'Buscar para comenzar',
    or: '..o elige una opción a continuación',
    producttrigger: 'Buscar Productos',
    faqtrigger: 'Ver preguntas frecuentes populares'
  },
  es: {
    title: 'Soporte Profesional',
    subtitle: 'Tenemos respuestas para sus preguntas',
    searchplaceholder: 'Buscar para comenzar',
    or: '..o elige una opción a continuación',
    producttrigger: 'Buscar Productos',
    faqtrigger: 'Ver preguntas frecuentes populares'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/Home/messages.js